import { useMutation } from '@apollo/client';
import {
  SELECT_COURIER_SHIPPING_METHOD,
  SELECT_HOME_SHIPPING_METHOD,
  SELECT_SHIPPING_PICKUP_METHOD,
} from '../../queries';
import {
  ISelectCourierShippingMethodQueryResult,
  ISelectHomeShippingMethodQueryResult,
  ISelectPickupShippingMethodQueryResult,
  IShippingMethodInfos,
  ShippingMethodTypes,
} from '@monofront/types';

export const useSelectShippingMethod = () => {
  const [selectCourierShippingMethodMutation] =
    useMutation<ISelectCourierShippingMethodQueryResult>(
      SELECT_COURIER_SHIPPING_METHOD,
      {
        context: {
          Headers: {
            'Content-Type': 'application/json; charset=utf-8',
          },
        },
      },
    );

  const [selectHomeShippingMethodMutation] =
    useMutation<ISelectHomeShippingMethodQueryResult>(
      SELECT_HOME_SHIPPING_METHOD,
      {
        context: {
          Headers: {
            'Content-Type': 'application/json; charset=utf-8',
          },
        },
      },
    );

  const [selectPickupShippingMethodMutation] =
    useMutation<ISelectPickupShippingMethodQueryResult>(
      SELECT_SHIPPING_PICKUP_METHOD,
      {
        context: {
          Headers: {
            'Content-Type': 'application/json; charset=utf-8',
          },
        },
      },
    );

  return (
    methodType: ShippingMethodTypes,
    shippingMethodSelected: IShippingMethodInfos & {
      shipmentId: string;
      tokenValue: string;
      addressId?: string;
    },
  ) => {
    switch (methodType) {
      case ShippingMethodTypes.HOME:
      case ShippingMethodTypes.CLICK_AND_COLLECT:
        return selectHomeShippingMethodMutation({
          variables: shippingMethodSelected,
        });
      case ShippingMethodTypes.PICKUP:
        return selectPickupShippingMethodMutation({
          variables: shippingMethodSelected,
        });
      case ShippingMethodTypes.COURIER:
        return selectCourierShippingMethodMutation({
          variables: shippingMethodSelected,
        });
      default:
        return Promise.reject('Method type not found');
    }
  };
};
